import {Filters} from '../../types/Filters';
import {selectFilterValues} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export function useFilterValues(): Filters {
  return useEagGridSelector(selectFilterValues);
}
